'use client';

import Button from '@/components/Button';
import { Event } from '../../events';
import { CalendarIcon, MapPinIcon, ClockIcon, TicketIcon } from '@heroicons/react/24/outline';
import { useLocalTime } from '@/lib/useLocalTime';

export function EventsDetails({ event, isPast }: { event: Event; isPast: boolean }) {
  const { localDate, localTime } = useLocalTime(event.timeStamp);

  return (
    <section className="max-w-section col-span-2 mt-8 md:mb-14 lg:p-8">
      <div className="flex flex-col items-center justify-center lg:items-start">
        <div className="text-eyebrow-strong hidden text-white lg:mb-4 lg:block lg:w-full lg:border-b lg:border-[#2E3135] lg:pb-4 lg:text-left">
          Event details
        </div>
        <div className="text-gray-400 flex flex-col flex-wrap justify-center gap-4 text-gray-4 md:flex-row lg:flex-col">
          <div className="flex items-center gap-2">
            <CalendarIcon className="h-5 w-5 text-[#00C851]" />
            {event.eventType === 'Online' ? `${localDate}` : `${event.date}`}
          </div>

          {event.locationShort && (
            <div className="flex items-center gap-2">
              <MapPinIcon className="h-5 w-5 text-[#00C851]" />
              {event.locationShort}
            </div>
          )}

          <div className="flex items-center gap-2">
            <ClockIcon className="h-5 w-5 text-[#00C851]" />
            {event.eventType === 'Online' ? `${localTime}` : `${event.time}`}
          </div>
          {!isPast && (
            <div className="flex items-center gap-2">
              <TicketIcon className="h-5 w-5 text-[#00C851]" />
              {event.isFree ? 'Free' : 'Paid'}
            </div>
          )}
          {!isPast && (
            <div className="mt-4 w-full justify-center md:flex md:w-1/2 lg:block lg:w-full">
              <Button href="#register-form" className="w-full">
                Register
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
